import React from "react";

const CartDesktop = React.lazy(() => import("./ui/Cart"));

export const CartPage = () => {
  return <CartDesktop />;
};
